import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, switchMap } from "rxjs/operators";
import { UserProfileService } from "src/app/_services/userprofile.service";
import {
  HasMFA,
  HasMFAError,
  HasMFASuccess,
  ResetMFA,
  ResetMFAError,
  ResetMFASuccess,
} from "./reset-mfa.actions";
import { HttpErrorResponse } from "@angular/common/http";
import { of } from "rxjs";

@Injectable()
export class ResetMFAEffects {
  constructor(
    private actions$: Actions,
    private userProfileService: UserProfileService
  ) {}

  public resetMfaEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ResetMFA),
      switchMap((payload) =>
        this.userProfileService.resetMfa$(payload.userId).pipe(
          map((result: boolean) => {
            return ResetMFASuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(ResetMFAError({ error: error }));
          })
        )
      )
    )
  );

  public hasMFAEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HasMFA),
      switchMap((payload) =>
        this.userProfileService.hasMfa$(payload.userId).pipe(
          map((result: boolean) => {
            return HasMFASuccess({ result: result });
          }),
          catchError((error: HttpErrorResponse) => {
            return of(HasMFAError({ error: error }));
          })
        )
      )
    )
  );
}
